const API_URL = process.env.REACT_APP_EVIDENCIAS_API || "/api/evidencias.php";

let csrfToken = null;

const request = async (action, { method = "GET", body } = {}) => {
  const headers = {};
  if (method === "POST" && csrfToken) headers["X-CSRF-Token"] = csrfToken;

  const response = await fetch(`${API_URL}?action=${action}`, {
    method,
    body,
    headers,
    credentials: "same-origin",
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || "Error de conexión con el servidor.");
    error.status = response.status;
    throw error;
  }
  return data;
};

const toForm = (fields) => {
  const form = new FormData();
  Object.entries(fields).forEach(([key, value]) => form.append(key, value));
  return form;
};

export const fetchProjects = async () => (await request("list")).projects;

export const getSession = async () => {
  const data = await request("session");
  csrfToken = data.csrf;
  return data.authenticated;
};

export const login = async (password) => {
  const data = await request("login", { method: "POST", body: toForm({ password }) });
  csrfToken = data.csrf;
};

export const logout = async () => {
  await request("logout", { method: "POST" });
  csrfToken = null;
};

const post = (action, fields = {}) => request(action, { method: "POST", body: toForm(fields) });

// Las fotos se identifican por su nombre de archivo (último tramo de la URL).
const fileName = (src) => src.split("/").pop();

export const fetchAdminProjects = async () => (await post("admin-list")).projects;
export const createProject = async (fields) => (await post("create-project", fields)).project;
export const updateProject = (id, fields) => post("update-project", { id, ...fields });
export const deleteProject = (id) => post("delete-project", { id });
export const moveProject = (id, direction) => post("move-project", { id, direction });
export const addImage = async (id, file, alt) => (await post("add-image", { id, file, alt })).image;
export const deleteImage = (id, src) => post("delete-image", { id, file: fileName(src) });
export const setCover = (id, src) => post("set-cover", { id, file: fileName(src) });

/**
 * Reduce y recomprime la imagen en el navegador antes de subirla, para no chocar con
 * el límite de subida del hosting (suele ser 2 MB). El servidor la vuelve a procesar igual.
 */
export const compressImage = (file, maxSide = 1920, quality = 0.85) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      const ctx = canvas.getContext("2d");
      // JPEG no tiene transparencia: sin fondo, las zonas transparentes de un PNG quedan negras.
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      canvas.toBlob(
        (blob) => (blob ? resolve(new File([blob], "foto.jpg", { type: "image/jpeg" })) : reject(new Error("No se pudo procesar la imagen."))),
        "image/jpeg",
        quality
      );
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("El archivo no es una imagen válida."));
    };
    img.src = url;
  });
